import { EmailProfileActionsContext } from '../Email.contexts'
import { useEmailProfileActions } from '../Email.hooks'

function EmailProfileActionsContextProvider({
  children,
  getPrintPageLink,
  shouldNavigateToList,
  useProfileActions = useEmailProfileActions,
  onSuccessMarkAsUnread,
  onSuccessUpdate,
  onUnread,
}) {
  const { requestCreationModal, ...restValue } = useProfileActions({
    getPrintPageLink,
    shouldNavigateToList,
    onSuccessMarkAsUnread,
    onSuccessUpdate,
    onUnread,
  })

  return (
    <EmailProfileActionsContext value={restValue}>
      {children}
      {requestCreationModal}
    </EmailProfileActionsContext>
  )
}

export default EmailProfileActionsContextProvider
